import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';
import { ProviderCompanyType } from 'src/types/providerCompany';

export interface TopBlockPropsType {
    data: ProviderCompanyType | null;
    idProviderCompany: string | undefined;
    newProviderCompany: boolean;
    disableEdit: boolean;
    disableDelete: boolean;
    handleSave: () => void;
    handleDeleteProviderCompany: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        icon: <DeleteIcon />,
                        onClick: () => {
                            props.handleDeleteProviderCompany();
                        },
                        tooltip: translate('providerCompanyDetail.deleteProviderCompany'),
                        hidden: props.disableDelete,
                        variant: 'outlined',
                    },
                    {
                        label: translate(
                            props.newProviderCompany ? 'providerCompanyDetail.create' : 'providerCompanyDetail.save'
                        ),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
